import React from 'react';
import ReactDOM from 'react-dom';
import { TEMPLATE_BASE_VERSIONS } from 'hook/useTemplate';

import sw from '../package.json';

import Structure from './structure';

import 'react-toastify/dist/ReactToastify.css';
import './index.css';

if (process.env.DEBUG_KEY) {
  if (!window[process.env.DEBUG_KEY]) window[process.env.DEBUG_KEY] = {};
  const debugObj = window[process.env.DEBUG_KEY];
  debugObj.projectName = sw.name;
  debugObj.projectVersion = sw.version;
  debugObj.projectEnv = process.env;
  debugObj.templates = TEMPLATE_BASE_VERSIONS;
  debugObj.netVersion = sw?.dependencies?.['net-com-lib'];
}

ReactDOM.render((
  <React.StrictMode>
    <Structure />
  </React.StrictMode>
),
document.getElementById('root'));
